// import LineGradient from "../components/LineGradient";
// import useMediaQuery from "../hooks/useMediaQuery";
// import { motion } from "framer-motion";
// import SkillsImage from "../assets/SkillsImage.png";
// import html from "../assets/html.png";
// import css from "../assets/css.png";
// import js from "../assets/js.png";
// import react from "../assets/react.png";
// import tailwindcss from "../assets/tailwindcss.png";
// import Python from "../assets/python.png";
// import mysql from "../assets/mysql.png";
// import C from "../assets/C.png";
// import c1 from "../assets/c1.png";
// import git from "../assets/git.png";
// import nodejs from "../assets/nodejs.png";
// import bootstrap from "../assets/bootstrap.png";

// const MySkills = () => {
    
//     const isAboveLarge = useMediaQuery("(min-width: 1060px)");
//     return (
//         <section id="skills" className="pt-10 pb-24">

//              {/* HEADER AND IMAGE SECTION */}
//             <div className="md:flex md:justify-between md:gap-16 mt-32">
//                 <motion.div
//                 className="md:w-1/3"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, x: -50 },
//                     visible: { opacity: 1, x: 0 },
//                 }}
//                 >
//                 <p className="font-playfair font-semibold text-4xl mb-5">
//                     MY <span className="text-red">SKILLS</span>
//                 </p>
//                 <LineGradient width="w-1/3" />
//                 <p className="mt-10 mb-7">
//                     These are the technologies I've worked with: 
//                 </p>
//                 </motion.div>

//                 <div className="mt-16 md:mt-0">
//                 {isAboveLarge ? (
//                     <div
//                     className="relative z-0 ml-20 before:absolute before:-top-10 before:-left-10
//                     before:w-full before:h-full before:border-2 before:border-blue before:z-[-1]"
//                     >
//                     <img
//                         alt="skills"
//                         className="z-10"
//                         src={SkillsImage}
//                     />
//                     </div>
//                     ) : (
//                         <img alt="skills" className="z-10" src={SkillsImage} />
//                     )}
//                 </div>
//             </div>

             

//             {/*SKILLS*/}

//             <div className="md:flex mt-12 md:justify-between gap-8">
                
//                 {/*HTML*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="HTML" src={html} alt="html-logo " style={{ border: '2px solid orange' }}/>
//                             <p className=" mt-1 ml-3" style={{ color:'#FFD580' }}>HTML</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*CSS*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay:0.05 ,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="CSS" src={css} alt="css-logo " style={{ border: '2px solid blue' }}/>
//                             <p className="mt-1 ml-5" style={{ color: 'lightblue' }}>CSS</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*JS*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.1 , duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="JavaScript" src={js} alt="JS-logo " style={{ border: '2px solid yellow' }}/>
//                             <p className=" mt-1 ml-1" style={{ color: 'lightyellow' }}>JavaScript</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*REACTJS*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.15 , duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="ReactJS" src={react} alt="react-logo " style={{ border: '2px solid aqua' }}/>
//                             <p className=" mt-1 ml-3" style={{ color: '#87CEEB' }}>ReactJS</p>
//                         </div>
//                     </div>
//                 </motion.div>

                

//                 {/*MYSQL*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.2 ,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="MySQL" src={mysql} alt="mysql-logo " style={{ border: '2px solid #ff8c00 ' }}/>
//                             <p className="mt-1 ml-3" style={{ color: '#FED8B1' }}>MySQL</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*PYTHON*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.25, duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="Python" src={Python} alt="python-logo " style={{ border: '2px solid yellow' }}/>
//                             <p className=" mt-1 ml-3" style={{ color: '#0096FF' }}>Python</p>
//                         </div>
//                     </div>
//                 </motion.div>
                
//                 {/*TAILWIND*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.3 , duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="TailwindCSS" src={tailwindcss} alt="rtailwind-logo " style={{ border: '2px solid aqua' }}/>
//                             <p className=" mt-1 ml-1" style={{ color: '#87CEEB' }}>TailwindCSS</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*C*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay: 0.35 , duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="C" src={C} alt="C-logo " style={{ border: '2px solid #6495ED' }}/>
//                             <p className=" mt-1 ml-8 "style={{ color: '#6495ED' }}>C</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*C++*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay:0.4,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="C++" src={c1} alt="c++ - logo " style={{ border: '2px solid #7DF9FF' }}/>
//                             <p className=" mt-1 ml-7" style={{ color: '#7DF9FF' }}>C++</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*GIT*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay:0.45,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="git" src={git} alt="git-logo " style={{ border: '2px solid orange' }}/>
//                             <p className=" mt-1 ml-7" style={{ color: '#FED8B1' }}>Git</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*NODEJS*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay:0.5,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="nodejs" src={nodejs} alt="nodejs-logo " style={{ border: '2px solid green' }}/>
//                             <p className=" mt-1 ml-3" style={{ color: 'green' }}>NodeJS</p>
//                         </div>
//                     </div>
//                 </motion.div>

//                 {/*BOOTSTRAP*/}
//                 <motion.div 
//                 className="md:w-1/3 mt-10"
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true, amount: 0.5 }}
//                 transition={{ delay:0.55,duration: 0.5 }}
//                 variants={{
//                     hidden: { opacity: 0, y: 50 },
//                     visible: { opacity: 1, y: 0 },
//                 }}
//                 >
//                     <div className="relative z-0 h-48 ">
//                         <div className="z-10">
//                             <img title="bootstrap" src={bootstrap} alt="bootstrap-logo " style={{ border: '2px solid blue' }}/>
//                             <p className=" mt-1 ml-2" style={{ color: '#7DF9FF' }}>Bootstrap</p>
//                         </div>
//                     </div>
//                 </motion.div>

//             </div>
//         </section>

//     );
// };

// export default MySkills;
import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Skill Icons
import html from "../assets/html.png";
import css from "../assets/css.png";
import js from "../assets/js.png";
import react from "../assets/react.png";
import tailwindcss from "../assets/tailwindcss.png";
import Python from "../assets/python.png";
import mysql from "../assets/mysql.png";
import C from "../assets/C.png";
import c1 from "../assets/c1.png";
import git from "../assets/git.png";
import nodejs from "../assets/nodejs.png";
import bootstrap from "../assets/bootstrap.png";
import java from "../assets/javapic.png";
import gif from "../assets/gif.gif"; 
import typescript from "../assets/ts.png";
import nextjs from "../assets/nextjs.png";
import mongo from "../assets/mongo.png";
import postgresql from "../assets/postgresql.png";
import php from "../assets/php.png";
import github from "../assets/github.png";
import express from "../assets/ex.png";
import xampp from "../assets/xampp.png";





const skillsData = [
  
  { title: "C", src: C, color: "#6495ED", border: "#6495ED" },
  { title: "C++", src: c1, color: "#7DF9FF", border: "#7DF9FF" },
  { title: "Java", src: java, color: "#87CEEB", border: "blue" }, 
  { title: "Python", src: Python, color: "#0096FF", border: "yellow" },
  { title: "MySQL", src: mysql, color: "#FED8B1", border: "#ff8c00" },
  { title: "HTML", src: html, color: "#FFD580", border: "orange" },
  { title: "CSS", src: css, color: "lightblue", border: "blue" },
  { title: "JavaScript", src: js, color: "lightyellow", border: "yellow" },
  { title: "ReactJS", src: react, color: "#87CEEB", border: "aqua" },
  { title: "NextJS", src: nextjs, color: "lightyellow", border: "white" },
  { title: "Git", src: git, color: "#FED8B1", border: "orange" },
  { title: "GitHub", src: github, color: "#FED8B1", border: "white" },
  { title: "TypeScript", src: typescript, color: "#7DF9FF", border: "blue" },
  { title: "NodeJS", src: nodejs, color: "lightgreen", border: "green" },
  { title: "ExpressJS", src: express, color: "#7DF9FF", border: "yellow" },
  { title: "MongoDB", src: mongo, color: "#FED8B1", border: "#6495ED" },
  { title: "PostgreSQL", src: postgresql, color: "#87CEEB", border: "blue" },
  { title: "PHP", src: php, color: "#7DF9FF", border: "purple" },
  { title: "TailwindCSS", src: tailwindcss, color: "#87CEEB", border: "aqua" },
  { title: "Bootstrap", src: bootstrap, color: "#7DF9FF", border: "blue" },
  { title: "XAMPP", src: xampp, color: "#87CEEB", border: "orange" },

  
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 10000,
  slidesToShow: 8,
  slidesToScroll: 8,
  autoplay: true,
  autoplaySpeed: 1500,
  cssEase: "ease-in-out",
  responsive: [
    { breakpoint: 1060, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1 } },
  ],
};

const MySkills = () => {
  return (
    <section id="skills" className="pt-10 pb-24">
      {/* HEADER SECTION: Text on left, GIF on right */}
      <div className="mt-32 flex flex-col md:flex-row items-center justify-between px-5 md:px-20">
        {/* Text */}
        <motion.div
          className="md:w-1/2 text-left"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}
        >
          <p className="font-playfair font-semibold text-4xl mb-5">
            MY <span className="text-red">SKILLS</span>
          </p>
          <LineGradient width="w-1/3" />
          <p className="mt-10 mb-7">These are the technologies I've worked with:</p>
        </motion.div>

        {/* GIF */}
        <motion.div
          className="md:w-1/2 mt-10 md:mt-0 flex justify-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{ hidden: { opacity: 0, x: 50 }, visible: { opacity: 1, x: 0 } }}
        >
          <img
            src={gif}
            alt="skills-gif"
            className="max-w-[450px] md:max-w-[450px] object-contain"
          />
        </motion.div>
      </div>

      {/* CAROUSEL */}
      <motion.div
        className="mt-20 px-5 md:px-20"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <Slider {...sliderSettings}>
          {skillsData.map(({ title, src, color, border }, index) => (
            <div key={index} className="flex flex-col items-center px-3">
              <div className="p-4 rounded-lg" style={{ border: `2px solid ${border}` }}>
                <img
                  src={src}
                  alt={`${title}-logo`}
                  title={title}
                  className="h-20 w-20 object-contain"
                />
              </div>
              <p className="mt-2 text-center" style={{ color }}>{title}</p>
            </div>
          ))}
        </Slider>
      </motion.div>
    </section>
  );
};

export default MySkills;
